import {useContext, useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import "../Styles/CourseDetailsPage.css";
import CourseRegistrationForm from "../components/CourseRegistrationForm.jsx";
import LoadingScreen from "../components/LoadingScreen";
import AuthContext from "../contexts/AuthContext";


const coursesData = [
    {
        id: 1,
        title: "MAMOGRAFİ",
        description: " ",
        image: "/images/mamografi_drawing.jpg",
        registrationPeriod: "15.02.2024 - 27.06.2025",
        educationPeriod: "15.02.2025 - 27.06.2025",
        capacity: "15 - 250",
        language: "Türkçe",
        duration: "60 Saat",
        certificate: "Katılım Sertifikası",
        code: "VRMAM - 25/1",
        coordinator: "Doç. Dr. Nuran Akyurt",
    },
];

const courseSchedule = [
    {
        week: 1,
        topics: [
            {
                date: "17.02.2025",
                day: "Pazartesi",
                topic: "Mamografinin Tanımı"
            },
            {
                date: "19.02.2025",
                day: "Çarşamba",
                topic: "Meme Anatomisi ve Fizyolojisi (VR Uygulama)"
            }
        ]
    },
    {
        week: 2,
        topics: [
            {
                date: "24.02.2025",
                day: "Pazartesi",
                topic: "Mamografi Cihazının Temel Bileşenleri"
            },
            {
                date: "26.02.2025",
                day: "Çarşamba",
                topic: "Mamografi Cihazının Temel Bileşenleri (VR Uygulama)"
            }
        ]
    },
    {
        week: 3,
        topics: [
            {
                date: "3.03.2025",
                day: "Pazartesi",
                topic: "Mamografinin Fiziksel Temelleri"
            },
            {
                date: "5.03.2025",
                day: "Çarşamba",
                topic: "Mamografi Çekim Teknikleri (VR Uygulama)"
            }
        ]
    },
    {
        week: 4,
        topics: [
            {
                date: "10.03.2025",
                day: "Pazartesi",
                topic: "Yardımcı Mamografi Pozisyonları"
            },
            {
                date: "12.03.2025",
                day: "Çarşamba",
                topic: "Mamografi Görüntüleme Kalitesi ve Teknik Parametreler (VR Uygulama)"
            }
        ]
    },
    {
        week: 5,
        topics: [
            {
                date: "17.03.2025",
                day: "Pazartesi",
                topic: "Dijital Mamografi Teknolojisi"
            },
            {
                date: "19.03.2025",
                day: "Çarşamba",
                topic: "Meme Kanseri Görüntüleme Algoritmaları (VR Uygulama)"
            }
        ]
    },
    {
        week: 6,
        topics: [
            {
                date: "24.03.2025",
                day: "Pazartesi",
                topic: "Mamografi Raporlama ve BIRADS Kategorileri"
            },
            {
                date: "26.03.2025",
                day: "Çarşamba",
                topic: "Sanal Gerçeklik ile Mamografi Uygulamaları"
            }
        ]
    },
    {
        week: 7,
        topics: [
            {
                date: "31.03.2025",
                day: "Pazartesi",
                topic: "Mamografide Radyasyon Dozu ve Güvenlik Önlemleri"
            },
            {
                date: "2.04.2025",
                day: "Çarşamba",
                topic: "Mamografide Artefaktlar (VR Uygulama)"
            }
        ]
    },
    {
        week: 8,
        topics: [
            {
                date: "7.04.2025",
                day: "Pazartesi",
                topic: "Mamografi Çekiminde Klinik Uygulamalar (VR)"
            },
            {
                date: "9.04.2025",
                day: "Çarşamba",
                topic: "Vize"
            }
        ]
    },
    {
        week: 9,
        topics: [
            {
                date: "14.04.2025",
                day: "Pazartesi",
                topic: "Kraniyokaudal (CC) Görüntüleme"
            },
            {
                date: "16.04.2025",
                day: "Çarşamba",
                topic: "Tanjensiyel Görüntüleme ve Özel Teknikler (VR Uygulama)"
            }
        ]
    },
    {
        week: 10,
        topics: [
            {
                date: "21.04.2025",
                day: "Pazartesi",
                topic: "Eklund Tekniği ve Parça Grafisi"
            },
            {
                date: "23.04.2025",
                day: "Çarşamba",
                topic: "Mamografide Kalite Standartları ve Protokoller (VR Uygulama)"
            }
        ]
    },
    {
        week: 11,
        topics: [
            {
                date: "28.04.2025",
                day: "Pazartesi",
                topic: "Kraniyokaudal ve Mediolateral Oblik Pozisyonlar"
            },
            {
                date: "30.04.2025",
                day: "Çarşamba",
                topic: "Mamografi Yorumlama Teknikleri (VR Uygulama)"
            }
        ]
    },
    {
        week: 12,
        topics: [
            {
                date: "5.05.2025",
                day: "Pazartesi",
                topic: "XLCC/XMCC Görüntüleme (VR Uygulama)"
            },
            {
                date: "7.05.2025",
                day: "Çarşamba",
                topic: "Ayakta Lateral Görüntüleme Teknikleri (VR Uygulama)"
            }
        ]
    },
    {
        week: 13,
        topics: [
            {
                date: "12.05.2025",
                day: "Pazartesi",
                topic: "Spesimen Görüntüleme ve Spot Görüntüleme"
            },
            {
                date: "14.05.2025",
                day: "Çarşamba",
                topic: "Klinik Uygulamalar ve Vaka Tartışmaları (VR Uygulama)"
            }
        ]
    },
    {
        week: 14,
        topics: [
            {
                date: "9.06.2025",
                day: "Pazartesi",
                topic: "Final"
            }
        ]
    }
];


function CourseDetailsPage() {
    const {id} = useParams();
    const course = coursesData.find((c) => c.id === parseInt(id));
    const [activeTab, setActiveTab] = useState("tanitim");
    const [showForm, setShowForm] = useState(false);
    //const schedule = courseSchedule;
    const [isRegistered, setIsRegistered] = useState(null);
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);


    const handleRegisterClick = () => {
        if (user) {
            // kullanıcı giriş yapmış → kayıta yönlendir
            handleRegister().then(r => console.log("navigated to register"));
        } else {
            // giriş yapılmamış → login sayfasına yönlendir
            alert("Önce giriş yapmalısınız.");
            navigate("/signin");
        }
    };

    const handleRegister = async () => {
        const email = localStorage.getItem("userEmail");

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/course-participants/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    courseId: id
                })
            });

            if (response.ok) {
                alert("Kayıt başarılı!");
                setIsRegistered(true); // Butonu değiştir
            } else {
                alert("Kayıt başarısız." + email + "id" + id);
            }
        } catch (err) {
            console.error("Kayıt hatası:", err);
            alert("Bir hata oluştu.");
        }
    };



    useEffect(() => {
        const checkIfRegistered = async () => {
            const email = localStorage.getItem("userEmail");

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/course-participants/getByUserEmailAndCourse`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        email: email,
                        courseId: id
                    }
                    )
                });

                if (!response.ok) {
                    // Beklenmedik hata varsa
                    setIsRegistered(false);
                    return;
                }

                // Eğer body boşsa (örneğin null dönüyorsa), json() hata verebilir
                const text = await response.text();

                if (!text) {
                    setIsRegistered(false); // null veya boş döndüyse kayıtlı değil
                } else {
                    const data = JSON.parse(text); // burada artık güvenli
                    setIsRegistered(!!data); // kayıt varsa true
                }
            } catch (err) {
                console.error("Hata:", err);
                setIsRegistered(false); // hata varsa da kayıtlı değilmiş gibi davran

            }
        };

        checkIfRegistered();
    }, [id]);


    if (!course) return <h2>Course not found</h2>;

    return (
        <div className="course-details-container">
            <div className="design-container">
                {/* Course Description */}
                <div className="col-md-7 bg-white details-section">
                    <h2>{course.title}</h2>
                    <p className="lead">{course.description}</p>

                    {/* Tabs Section */}
                    <div className="tabs">
                        <button className={activeTab === "tanitim" ? "active" : ""}
                                onClick={() => setActiveTab("tanitim")}>
                            Tanıtım
                        </button>
                        <button className={activeTab === "hedef" ? "active" : ""} onClick={() => setActiveTab("hedef")}>
                            Eğitim Hedefi ve Katılımcı Profili
                        </button>
                        <button className={activeTab === "ders" ? "active" : ""} onClick={() => setActiveTab("ders")}>
                            Ders Programı
                        </button>
                        <button className={activeTab === "bilgi" ? "active" : ""} onClick={() => setActiveTab("bilgi")}>
                            Bilgi Formu
                        </button>
                    </div>
                    <div className="tab-content">
                        {activeTab === "tanitim" && <p>Meme sağlığında erken teşhis ve doğru görüntüleme yöntemlerinin önemi giderek artmaktadır. Bu programda, mamografinin temel ilkeleri ve uygulama teknikleri, sanal gerçeklik (VR) destekli etkileşimli içeriklerle aktarılır.
                            Eğitim; teorik bilgi, uygulamalı simülasyonlar ve gerçek vaka senaryoları ile desteklenir. Katılımcıların mesleki becerilerini geliştirmesi, güncel teknikleri deneyimlemesi ve güvenle uygulayabilmesi hedeflenmektedir.
                        </p>}
                        {activeTab === "hedef" &&
                            (
                                <div>
                                    <h2>Eğitim Hedefi</h2>
                                    <p>Bu program, mamografi sürecinin teknik, klinik ve etik boyutlarını
                                        VR teknolojisi ile birleştirerek öğretmeyi amaçlamaktadır. 360° senaryolarla
                                        desteklenen uygulamalar sayesinde katılımcılar cihaz kullanımı, pozisyonlama ve
                                        değerlendirme süreçlerini birebir deneyimleyebilecektir. VR ortamında tekrar
                                        edilebilir eğitim senaryoları, kalıcı öğrenme ve özgüven gelişimi sağlar.</p>
                                    <h2>Hedef Kitle</h2>
                                    <ul>
                                        <li>Tıbbi Görüntüleme Teknikleri Öğrencileri, Tıbbi ve Radyoloji teknikerleri ve
                                            teknisyenleri
                                        </li>
                                        <li>Sağlık Bilimleri Fakültesi öğrencileri</li>
                                        <li>Mamografi ünitesinde görev yapan tüm sağlık çalışanı</li>
                                        <li>Kadın sağlığı alanında çalışan aile sağlığı merkezi çalışanları</li>
                                        <li>Mesleki gelişimini VR teknolojisi ile desteklemek isteyen sağlık
                                            profesyonelleri
                                        </li>

                                    </ul>
                                    <h2>Neden Katılmalısın?</h2>
                                    <ul>
                                        <li>Gerçek vakalarla birebir etkileşimli öğrenme ortamı</li>
                                        <li>Uygulamalı mamografi çekim teknikleri</li>
                                        <li>Hastane ortamında deneyim</li>
                                        <li>Klinik standartlara uygun BIRADS raporlama pratiği</li>
                                        <li>Eğitimi dilediğiniz kadar tekrar etme imkânı</li>
                                        <li>Dijital başarı sertifikası alma fırsatı</li>

                                    </ul>
                                </div>
                            )}
                        {activeTab === "ders" && <>
                            <table className="table table-striped schedule-table">
                                <thead>
                                <tr>
                                    <th>Hafta</th>
                                    <th>Konular</th>
                                    <th>Tarih</th>
                                    <th>Gün</th>
                                </tr>
                                </thead>
                                <tbody>
                                {courseSchedule.map((week) =>
                                    week.topics.map((topic, index) => (
                                        <tr key={`${week.week}-${index}`}>
                                            <td>{week.week}</td>
                                            <td>{topic.topic}</td>
                                            <td>{topic.date}</td>
                                            <td>{topic.day}</td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>

                        </>
                        }
                        {activeTab === "bilgi" &&
                            (
                                <div>
                                    <h2>Bu Kursta Neler Öğreneceksiniz?</h2>
                                    <ol>
                                        <li>Mamografi cihazlarının bileşenleri ve çalışma prensipleri (VR ortamında
                                            etkileşimli anlatım)
                                        </li>
                                        <li>Çekim teknikleri (CC, MLO vb.) ve hasta pozisyonlama uygulamaları</li>
                                        <li>Görüntü kalitesi ve artefakt değerlendirmesi, klinik görüntüleme
                                            kriterleriyle birlikte
                                        </li>
                                        <li>Radyasyon güvenliği ve hasta hazırlığı (senaryo tabanlı etkileşimli
                                            uygulamalarla)
                                        </li>
                                        <li>VR vaka senaryoları ile karar verme ve uygulama becerilerinin
                                            pekiştirilmesi
                                        </li>
                                        <li>BIRADS sistematiği ve mamografi raporlaması, görsel örneklerle destekli
                                            anlatım
                                        </li>
                                    </ol>
                                </div>
                            )}
                    </div>
                </div>

                {/* Course Image & Info Section */}
                <div className="col-md-5 course-info-container">
                    <img src={course.image} alt={course.title} className="course-image"/>
                    <div className="info-card">
                        {isRegistered === null ? (
                            <LoadingScreen/>
                        ) : isRegistered ? (
                            <Link to={`/course-content/${id}`} className="btn-register">Ders İçeriğini Gör</Link>
                        ) : (
                            <button onClick={() => handleRegisterClick()} className="btn-register" style={{width:'100%'}}>Kaydol</button>
                        )}

                        <div className="info-item"><i className="far fa-calendar-alt"></i><strong>Kayıt
                            Dönemi:</strong> {course.registrationPeriod}</div>
                        <div className="info-item"><i className="far fa-calendar-check"></i><strong>Eğitim
                            Dönemi:</strong> {course.educationPeriod}</div>
                        <div className="info-item"><i
                            className="fas fa-users"></i><strong>Kontenjan:</strong> {course.capacity}</div>
                        <div className="info-item"><i className="fas fa-language"></i><strong>Eğitim
                            Dili:</strong> {course.language}</div>
                        <div className="info-item"><i className="fas fa-clock"></i><strong>Eğitim
                            Süresi:</strong> {course.duration}</div>
                        <div className="info-item"><i className="fas fa-certificate"></i><strong>Belge
                            Türü:</strong> {course.certificate}</div>
                        <div className="info-item"><i className="fas fa-id-badge"></i><strong>Eğitim
                            Kodu:</strong> {course.code}</div>
                        <div className="info-item"><i
                            className="fas fa-user"></i><strong>Koordinatör:</strong> {course.coordinator}</div>
                    </div>
                </div>
            </div>

            {/* Registration Form Modal */}
            {showForm && (
                <div className="modal-overlay">
                    <div className="form-container">
                        <CourseRegistrationForm onClose={() => setShowForm(false)}/>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CourseDetailsPage;
